/*
 * Copyright (C) 2024 S&P Global.
 * All Rights Reserved
 */
export function getFormattedTime(date?: Date): string {
  const effectiveDate: Date = date ? date : new Date();
  const options: Intl.DateTimeFormatOptions = {
    hour12: false,
    hour: "2-digit",
    minute: "2-digit",
    second: "2-digit",
    fractionalSecondDigits: 3,
  };
  return new Intl.DateTimeFormat(Intl.DateTimeFormat().resolvedOptions().locale, options).format(effectiveDate);
}
